import React from "react"
import PropTypes from "prop-types"

import {Col, Row} from "react-bootstrap"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import Hr from "@irati/ui/src/Layout/Hr"
import Total from "../../components/OrderSummary/Total"
import Subtotal from "../OrderSummary/Subtotal"

/**
 * Displays products & total for order summary on deal success.
 */
const OrderDetails = ({order, currency}) => {
  return (
    <div>
      <Hr />
      <Subtotal
        subtotal={order.totalBeforeDiscount.value}
        discount={order.totalBeforeDiscount.value - order.total.value}
        padSubtotal
        currency={currency} />
      <Row>
        <Col xs={10}>
          <FormattedMessage id="perks.components.dealSuccessOrderSummary.orderDetails.vat" />
        </Col>
        <Col xs={2}>
          <div className="pull-right">
            <FormattedCurrency isCents={false} currency={currency} value={order.totalVAT.value} />
          </div>
        </Col>
      </Row>
      <Hr />
      <Total paid total={order.total.value} currency={currency} />
    </div>)
}

OrderDetails.propTypes = {
  order: PropTypes.shape({
    totalBeforeDiscount: PropTypes.object,
    totalVAT: PropTypes.object,
    total: PropTypes.object
  }).isRequired,
  currency: PropTypes.string
}
OrderDetails.defaultProps = {
  currency: ""
}
export default OrderDetails
